import { Employee } from '@/lib/request/types/employee';
import {
  AnalyticsContext,
  AnalyticsService,
  AnalyticsServiceContextParams,
  User,
} from './analytics';
import { useAnalyticsService } from './useAnalyticsService';
import { getKioskCreatorUuid } from '../auth';

export function reloadAnalyticsService(
  newContextValues: AnalyticsServiceContextParams = {}
): AnalyticsService {
  if (!window.analyticsService) {
    return useAnalyticsService();
  }

  const updatedContext = getUpdatedAnalyticsContext(newContextValues);

  sendAnalyticsIdentify(updatedContext);
  sendAnalyticsGroup(updatedContext);

  window.analyticsService = window.dpAnalytics.createAnalyticsService({
    send(name: string, event: string) {
      // calling segment track
      window.analytics.track(name, event);
    },
    context: updatedContext,
    installationId: updatedContext.installation.ID,
  });

  return useAnalyticsService();
}

function getUpdatedAnalyticsContext({
  employee,
}: AnalyticsServiceContextParams): AnalyticsContext {
  return {
    ...window.__APP__.analyticsContext,
    user: {
      ...window.__APP__.analyticsContext.user,
      ...getUserFromEmployee(employee),
    },
  };
}

function getUserFromEmployee(employee?: Employee): User {
  const user: User = {
    deputyEmailFlag: false,
    deputyUUID: '',
    installationUserID: '',
    anonymousID: '',
    role: undefined,
  };

  if (employee) {
    user.deputyEmailFlag = !!employee.EmailAddress?.match(/@deputy.com/);
    user.deputyUUID = getUserAnalyticsUUID(employee);
    user.installationUserID = employee.UserId.toString();
    user.role = {
      ID: employee.RoleId,
      name: employee.RoleName,
      permissions: {
        canApproveTimesheets: employee.CanApproveTimesheets,
        canExportTimesheets: employee.CanExportTimesheets,
        canRoster: employee.CanManageRoster,
      },
    };
  } else {
    user.deputyUUID = getKioskCreatorUuid();
  }

  return user;
}

function getUserAnalyticsUUID(employee: Employee): string {
  const userInstallationId = employee.UserId;
  const installationId = window.__APP__.analyticsContext.installation.ID;

  return employee.UserUuid || `deputy/${installationId}/${userInstallationId}`;
}

function sendAnalyticsIdentify(context: AnalyticsContext) {
  const deputyUUID = context.user.deputyUUID;
  if (deputyUUID) {
    window.analytics.identify(deputyUUID, context.user);
  }
}

function sendAnalyticsGroup(context: AnalyticsContext) {
  const installationId = context.installation.ID;
  const deputyUUID = context.user.deputyUUID;

  if (installationId && deputyUUID) {
    window.analytics.group(installationId, context.installation);
  }
}
